import {
    createApi,
    fetchBaseQuery
  } from "@reduxjs/toolkit/query/react";
import { RootState } from '../'

const APIM_SUBSCRIPTION_VALUE = process.env.REACT_APP_OPERATION_ASSISTANT_APIM_SUBSCRIPTION_VALUE
const BASE_URL = process.env.REACT_APP_OPERATION_ASSISTANT_API_URL

type PolygonCoordinates = number[][][];
type MultiPolygonCoordinates = number[][][][];

interface GeoJSONGeometry {
  type: 'Polygon' | 'MultiPolygon';
  coordinates: PolygonCoordinates | MultiPolygonCoordinates;
}

interface GeoJSONFeature {
  type: 'Feature';
  geometry: GeoJSONGeometry;
  properties?: Record<string, any>;
}

export interface Map2ResultType {
  type: 'FeatureCollection';
  features: GeoJSONFeature[];
  source?: string;
}

export const map2Api = createApi({
    reducerPath: "map2Api",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: async (headers, { getState }) => {
            const state = getState() as RootState

            headers.set('Content-Type', `application/json`)
            headers.set('Ocp-Apim-Subscription-Key', `${APIM_SUBSCRIPTION_VALUE}`)
            headers.set('Authorization', `Bearer ${state.auth.idToken}`)
            return headers
        }
    }),
    tagTypes: ["Map2"],
    endpoints: (builder) => ({
        getMap2Boundary: builder.mutation<Map2ResultType, {account_id: string, lat: number, lon: number}>({
            query: (params) => ({
                url: `/polygons`,
                method: 'POST',
                body: params
            })
        })
    })
})

export const { useGetMap2BoundaryMutation } = map2Api;